module.exports = __webpack_public_path__ + "img/pns_names.c652e167.png";